define.alias("shared/components/shared/mobile/drawer/layout", "media/components/shared/mobile/drawer/layout");